import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["checked", "id", "name", "disabled", "indeterminate"]

import { computed } from 'vue';

import { CheckmarkIcon, MinusIcon, SolidCheckIcon } from '@/components/svg';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomCheckbox',
  props: {
    modelValue: { type: Boolean },
    bgColor: { default: 'transparent' },
    borderColor: { default: 'var(--ch-blue-100)' },
    borderWidth: { default: '1px' },
    svgFill: { default: 'var(--ch-blue-100)' },
    rounded: { type: [String, Boolean], default: '3px' },
    variant: { default: 'outline' },
    testId: { default: 'custom-checkbox' },
    disabled: { type: Boolean },
    name: {},
    id: {},
    indeterminate: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};

const getBorderRadius = () => {
  if (typeof props.rounded === 'string') {
    return props.rounded;
  } else if (props.rounded === true) {
    return '100%';
  } else {
    return '0px';
  }
};

const spanStyles = computed(() => ({
  background: props.bgColor ?? 'transparent',
  border: `${props.borderWidth} solid ${props.borderColor ?? 'var(--ch-blue-100)'}`,
  borderRadius: getBorderRadius(),
}))

const variantStyles = computed(() => {
  const isSelectedOrIndeterminate = props.modelValue || props.indeterminate;

  return {
    background: props.variant === 'filled' && isSelectedOrIndeterminate ? 'var(--ch-blue-100)' : props.bgColor,
    border: `${props.borderWidth} solid ${props.variant === 'filled' && isSelectedOrIndeterminate ? 'var(--ch-blue-100)' : props.borderColor}`,
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", { "data-testid": __props.testId }, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: __props.modelValue,
      id: __props.id,
      name: __props.name ?? __props.id,
      disabled: __props.disabled,
      indeterminate: __props.indeterminate,
      onChange: onChange
    }, null, 40, _hoisted_2),
    _createElementVNode("span", {
      class: "flex-center",
      style: _normalizeStyle({ ...spanStyles.value, ...variantStyles.value })
    }, [
      (__props.indeterminate)
        ? (_openBlock(), _createBlock(_unref(MinusIcon), {
            key: 0,
            class: "dash-icon",
            fill: __props.svgFill
          }, null, 8, ["fill"]))
        : (__props.modelValue && __props.variant === 'filled')
          ? (_openBlock(), _createBlock(_unref(SolidCheckIcon), {
              key: 1,
              class: "check-icon",
              fill: __props.svgFill
            }, null, 8, ["fill"]))
          : (__props.modelValue)
            ? (_openBlock(), _createBlock(_unref(CheckmarkIcon), {
                key: 2,
                class: "check-icon",
                fill: __props.svgFill
              }, null, 8, ["fill"]))
            : _createCommentVNode("", true)
    ], 4)
  ], 8, _hoisted_1))
}
}

})